import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-tooltip-renderer',
  template: `
    <div>
      <span
        class="text-dark"
        nz-tooltip
        [nzTooltipTitle]="cellValue"
        [nzTooltipColor]="'#fff'"
      >
        {{ cellValue ? cellValue : ('general.n/a' | translate) }}
      </span>
    </div>
  `,
  styles: [
    `
      span {
        line-height: 5px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowTextTooltipRendererComponent implements AgRendererComponent {
  public cellValue!: string;

  async agInit(params: ICellRendererParams) {
    this.cellValue = params.value;
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = params.value;
    return true;
  }
}
